<div class="card is-shadowless is-fullwidth is-fullheight">
  <h3
    class="is-uppercase has-text-weight-bold mb-3"
    [ngClass]="{ 'title is-7 has-text-grey-dark': applyStyling}"
  >
    {{ aggregation.longLabel || aggregation.label }}
  </h3>

  <div *ngIf="aggregation.description"
       [innerHTML]="aggregation.description"
       [ngClass]="{'subtitle is-7 has-text-grey': applyStyling}">
  </div>

  <div *ngIf="aggregation.descriptionHeading"
       [innerHTML]="aggregation.descriptionHeading"
       class="subtitle is-7 has-text-grey is-uppercase has-text-weight-bold pt-2 mb-0">
  </div>

  <!-- Nav -->
  <nav class="level is-mobile is-flex mb-2" *ngIf="aggregation.id!='summaryOverview'">
    <div class="level-left">
      <div class="level-item" *ngIf="aggregation.datasets.length > 1">
        <div class="select is-small">
          <select name="dataset-select" (change)="selectDataset($event.target)">
            <option
              [value]="dataset.id"
              *ngFor="let dataset of aggregation.datasets"
            >
              {{ dataset.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <a
          class="button is-small is-link-light is-hidden-touch"
          *ngIf="selectedDataset?.csv"
          (click)="downloadDataset(selectedDataset)"
        >
          <span>Download dataset</span>
          <span class="icon is-small">
            <i class="fa-solid fa-file-download"></i>
          </span>
        </a>
        <a
          class="button is-small is-link-light is-hidden-desktop"
          *ngIf="selectedDataset?.csv"
          (click)="downloadDataset(selectedDataset)"
        >
          <span class="icon is-small">
            <i class="fa-solid fa-file-download"></i>
          </span>
        </a>
      </div>
    </div>
  </nav>

  <!-- Chart -->
  <ng-container *ngIf="selectedDataset && aggregation.chartTypes">
    <app-sunburst
      *ngIf="aggregation.chartTypes[0] === ChartType.Sunburst"
      [dataset]="selectedDataset"
      [selectedFamily]="selectedFamily"
    ></app-sunburst>
    <app-stacked-bar
      *ngIf="aggregation.chartTypes[0] === ChartType.StackedBarChart"
      [dataset]="selectedDataset"
    ></app-stacked-bar>
    <app-world-map
      *ngIf="aggregation.chartTypes[0] === ChartType.WorldMap"
      [dataset]="selectedDataset"
    ></app-world-map>
    <app-pie-chart
      *ngIf="aggregation.chartTypes[0] === ChartType.PieChart"
      [dataset]="selectedDataset"
    ></app-pie-chart>
    <app-iframe
      *ngIf="aggregation.chartTypes[0] === ChartType.Iframe"
      [dataset]="selectedDataset"
    >
    </app-iframe>
    <app-bar-chart
      *ngIf="aggregation.chartTypes[0] === ChartType.BarChart"
      [dataset]="selectedDataset"
      [selectedFamily]="selectedFamily"
    >
    </app-bar-chart>
    <app-scatter-plot
      *ngIf="aggregation.chartTypes[0] === ChartType.ScatterPlot"
      [dataset]="selectedDataset"
    >
    </app-scatter-plot>
  </ng-container>
  <ng-container *ngIf="selectedDataset && aggregation.visualisation">
    <app-aggregation-table
      *ngIf="aggregation?.visualisation === 'table'"
      [aggregation]="aggregation"
      [selectedCountries]="selectedCountries"
      [selectedIncentiveType]="selectedIncentiveType"
    >
    </app-aggregation-table>
    <app-pie-chart
      *ngIf="aggregation?.visualisation === 'pieChart'"
      [dataset]="selectedDataset"
      [chartType]="'doughnut'"
      (sliceClick)="onPieSliceClick($event)">
    ></app-pie-chart>
  </ng-container>
</div>
